






import Vue, { PropOptions } from 'vue'
import { Specification } from '~/models/classified/types'
import { mapGetters } from 'vuex'
import NewBadge from '~/components/car/classifieds/badges/NewBadge.vue'

export default Vue.extend({
  components: {
    NewBadge
  },
  props: {
    specification: {
      type: Object,
      required: true
    } as PropOptions<Specification>
  },
  computed: {
    ...mapGetters({
      classifiedIsNew: 'classifieds/view/isNew'
    })
  }
})
